import React from 'react'

import { useOrganizationPublicInfo } from '../queries'
import { Avatar, Skeleton } from 'antd'
import { TranslatedMessage } from '@library/react-toolkit'

const OrganizationLogo = ({ orgName }: { orgName: string }) => {
  const orgInfoQuery = useOrganizationPublicInfo(orgName)

  const org = orgInfoQuery.data

  const image =
    !!org && !!org.logoUrl ? `/images/uaa/${org.logoUrl}` : undefined

  return (
    <>
      <Skeleton loading={orgInfoQuery.isLoading}>
        <Avatar size={128} shape="square" src={image}>
          {image === undefined ? <TranslatedMessage id="companyLogo" /> : null}
        </Avatar>
      </Skeleton>
    </>
  )
}
export default OrganizationLogo
